export interface MenuLink { title: string; url: string }
export interface Teaser { id: string; title: string; url: string; summary: string; image: string; alt: string; imageLeft: boolean }

type Display = "teaser" | "full" | "large";
type TeaserOpts = { display?: Display; imageLeft?: boolean };

export function cleanPath(path?: string): string {
	if (typeof path !== 'string') return '/';
	let p = path.split('?')[0].split('#')[0];
	p = p.replace(/\.html$/, '');
	p = p.replace(/\/\d+\/page$/, '');
	if (p.length > 1) p = p.replace(/\/+$/, '');
	if (!p) return '/';
	if (!p.startsWith('/')) p = '/' + p;
	return p;
}

export function stripTags(html?: any): string {
	if (typeof html !== 'string') return '';
	return html
		.replace(/<[^>]*>/g, ' ')
		.replace(/&nbsp;/g, ' ')
		.replace(/&quot;/g, '"')
		.replace(/&#39;/g, "'")
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/&amp;/g, '&')
		.replace(/\s+/g, ' ')
		.trim();
}

const firstImage = (image: any) => Array.isArray(image) ? image[0] : image;

export function imageSrc(image: any, display?: Display): string {
	const first = firstImage(image);
	let d: any = first?.[display ?? 'teaser'];
	if (typeof d === 'string' && d.trim().startsWith('{')) {
		try { d = JSON.parse(d); } catch (e) {}
	}
	if (d && typeof d === 'object' && d.url) return d.url;
	if (typeof d === 'string' && !d.trim().startsWith('{')) return d;
	return first?.url || '';
}

export function toTeaser(entity: any, opts?: TeaserOpts): Teaser {
	const title = entity?.title || '';
	return {
		id: String(entity?.id ?? ''),
		title,
		url: entity?.url || '',
		summary: stripTags(entity?.summary),
		image: imageSrc(entity?.image, opts?.display),
		alt: firstImage(entity?.image)?.alt || title,
		imageLeft: !!opts?.imageLeft,
	};
}

export function toTeasers(edges: any, opts?: TeaserOpts): Teaser[] {
	if (!Array.isArray(edges)) return [];
	return edges.filter((e: any) => e).map((e: any) => toTeaser(e, opts));
}

export function toMenuLinks(menu: any): MenuLink[] {
	if (!Array.isArray(menu?.items)) return [];
	return menu.items
		.map((i: any) => ({ title: i?.title || '', url: i?.url?.path || '/' }))
		.filter((i: MenuLink) => i.title);
}
